export const getFileNameFromUrl = (url: string): string => {
    const urlParams = new URLSearchParams(url.split('?')[1]);
    return urlParams.get('fileName') || url;
};